import * as Styled from './LoaderSpinner.styled'

export const LoaderSpinner = ({
	isDisplayed = false,
	className = '',
	size,
	color,
	borderWidth = '2px',
	delayDisplay = true,
	styles,
	ref
}:{
	isDisplayed: boolean;
	className?: string;
	size?: string;
	color?: string;
	borderWidth?: string;
	styles?: React.CSSProperties;
	delayDisplay?: boolean;
	ref?: React.Ref<HTMLDivElement>;
}) => {
	return (
		<Styled.LoaderWrapper 
			ref={ref} 
			className={`loader-spinner ${className}`} 
			data-is-displayed={isDisplayed}
			data-delay-display={delayDisplay}
			style={{
				...size && { width: size }, 
				...size && { height: size },
				...styles && styles
			}}
		>
			<Styled.Loader 
				className="loader-spinner-animated" 
				style={{
					...color && { borderColor: color },
					...color && { borderBottomColor: 'transparent' },
					...borderWidth && { borderWidth : borderWidth }
				}}
			/>
		</Styled.LoaderWrapper>
	)
	}